<div class="work-unit-filter" ng-if="vm.visible">
    <div class="filter" ng-show="!vm.enabled" ng-click="vm.enable($event)">
        <c-checkbox checked="vm.enabled" class="toggle" ></c-checkbox>
        <span class="text">{{'workUnitFilter.concerned' | translate}}</span>
    </div>
    <div class="filter enabled" ng-show="vm.enabled">
        <c-checkbox checked="vm.enabled" class="toggle" ng-click="vm.disable()"></c-checkbox>
        <span class="text" c-select options="vm.workUnits" selected-option="vm.selectedWorkUnit"></span>
        <i class="fa fa-search-minus" ng-click="vm.zoomOut()"></i>
        <i class="fa fa-search-plus" ng-click="vm.zoomIn()"></i>
    </div>
</div>